export enum ELocale {
  RU = 'ru',
  EN = 'en',
}

export const DEFAULT_LOCALE = ELocale.RU
export const LOCALE_STORAGE_KEY = 'app_locale'

export const SUPPORTED_LOCALES: ReadonlyArray<ELocale> = [ELocale.RU, ELocale.EN]

export function isSupportedLocale(val: unknown): val is ELocale {
  return typeof val === 'string' && SUPPORTED_LOCALES.includes(val as ELocale)
}
